export default "__VITE_ASSET__Ab2ISvwV__"